import React from 'react'
import Wosenderaboutenable from './Wosenderaboutenenable'
import Helpingbusiness from './Helpingbusiness'
import Whatwedo from './Whatwedo'
import FAQ from './FAQ'
import GetStartedNow from './GetStartedNow'
import Navbar from './Navbar'
import Footer from './Footer'


const Aboutpage = () => {
  return (
    <>
    <Navbar/>
    <Wosenderaboutenable/>
    <Helpingbusiness/>
    <Whatwedo/>
    <FAQ/>
    <GetStartedNow/>
    <Footer/>
    </>
  )
}

export default Aboutpage